import clsx from 'clsx';

export const HorizontalLine = ({ className }: { className?: string }) => {
  return (
    <div
      className={clsx(
        'from-slate-white via-bd-dark/80 to-slate-white bg-linear-to-r mt-2 h-[1px]',
        className
      )}
    ></div>
  );
};
